import { Group, Loader } from "@mantine/core";

const FallbackLoader = () => {
	return (
		<Group
			position="center"
			style={{
				width: "100%",
				height: "100%",
				zIndex: "102",
			}}
		>
			<Loader size={"xl"} />
		</Group>
	);
};

export default FallbackLoader;
